function StickyFilters() {
  const BREAKPOINT = 992;
  const headerElement = document.querySelector('.main-header > .main-header');
  const PRODUCT_FILTER = document.querySelector('.section-product-filter');
  const BLOG_FILTER = document.querySelector('.section-blog-filter');
  const BLOG_FILTER_MOBILE = document.querySelector('.section-blog-filter--mobile');
  const BLOG_GRID = document.querySelector('.section-blog-grid');

  let headerHeight, productFilterOgTop, blogFilterOgTop, mobileBlogFilterOgTop, desktopFilterHeight, mobileFilterHeight, desktopFilterLeft, mobileFilterLeft;

  const getComputedStyle = (element, property) => {
    return window.getComputedStyle(element).getPropertyValue(property);
  }

  const convertStringToInt = (string) => {
    return parseInt(string, 10);
  }

  const setFilterLayouts = () => {
    headerHeight = headerElement.offsetHeight;

    if (PRODUCT_FILTER) {
      productFilterOgTop = PRODUCT_FILTER.getBoundingClientRect().top + window.scrollY;
      PRODUCT_FILTER.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
    }
  
    if (BLOG_FILTER) {
      const paddingLeft = getComputedStyle(BLOG_GRID, 'padding-left');
      const paddingLeftInt = convertStringToInt(paddingLeft);

      desktopFilterHeight = BLOG_FILTER.offsetHeight;
      blogFilterOgTop = BLOG_FILTER.getBoundingClientRect().top + window.scrollY;
      desktopFilterLeft = BLOG_GRID.getBoundingClientRect().left;
      BLOG_FILTER.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
      BLOG_FILTER.style.setProperty('--mx-sticky-left', `${desktopFilterLeft + paddingLeftInt}px`);
    }
  
    if (BLOG_FILTER_MOBILE) {
      const paddingLeft = getComputedStyle(BLOG_GRID, 'padding-left');
      const paddingLeftInt = convertStringToInt(paddingLeft);
      
      mobileFilterHeight = BLOG_FILTER_MOBILE.offsetHeight;
      mobileBlogFilterOgTop = BLOG_FILTER_MOBILE.getBoundingClientRect().top + window.scrollY;
      mobileFilterLeft = BLOG_GRID.getBoundingClientRect().left;
      BLOG_FILTER_MOBILE.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
      BLOG_FILTER_MOBILE.style.setProperty('--mx-sticky-left', `${mobileFilterLeft + paddingLeftInt}px`);
    }
  }

  const updateFilterLayouts = () => {
    headerHeight = headerElement.offsetHeight;
    const scrollY = window.scrollY

    if (PRODUCT_FILTER) {
      PRODUCT_FILTER.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
    }

    if (window.innerWidth >= BREAKPOINT) {
      if (BLOG_FILTER) {
        const paddingLeft = getComputedStyle(BLOG_GRID, 'padding-left');
        const paddingLeftInt = convertStringToInt(paddingLeft);
  
        blogFilterOgTop = (blogFilterOgTop !== 0)
          ? blogFilterOgTop
          : BLOG_FILTER.getBoundingClientRect().top + scrollY;

        desktopFilterLeft = BLOG_GRID.getBoundingClientRect().left;
        BLOG_FILTER.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
        BLOG_FILTER.style.setProperty('--mx-sticky-left', `${desktopFilterLeft + paddingLeftInt}px`);

        handleFilter(BLOG_FILTER, blogFilterOgTop, desktopFilterHeight, scrollY + headerHeight);
      }
    } else {
      if (BLOG_FILTER_MOBILE) {
        const paddingLeft = getComputedStyle(BLOG_GRID, 'padding-left');
        const paddingLeftInt = convertStringToInt(paddingLeft);
  
        mobileBlogFilterOgTop = (mobileBlogFilterOgTop !== 0)
        ? mobileBlogFilterOgTop
        : BLOG_FILTER_MOBILE.getBoundingClientRect().top + scrollY;

        mobileFilterLeft = BLOG_GRID.getBoundingClientRect().left;
        BLOG_FILTER_MOBILE.style.setProperty('--mx-sticky-top', `${headerHeight}px`);
        BLOG_FILTER_MOBILE.style.setProperty('--mx-sticky-left', `${mobileFilterLeft + paddingLeftInt}px`);

        handleFilter(BLOG_FILTER_MOBILE, mobileBlogFilterOgTop, mobileFilterHeight, scrollY + headerHeight);
      }
    }
  }

  const handleFilter = (filter, filterOgTop, filterHeight, scrollY) => {
    if (filter) {
      if (scrollY >= filterOgTop) {
        filter.style.position = 'fixed';
        filter.setAttribute('blog-filter-fixed', '');
        BLOG_GRID.style.paddingTop = `${filterHeight}px`;
      } else {
        filter.style.position = '';
        filter.removeAttribute('blog-filter-fixed');
        BLOG_GRID.style.paddingTop = '';
      }
    } else return null;
  };
  
  const handleScroll = () => {
    const scrollY = window.scrollY + headerHeight;
  
    if (PRODUCT_FILTER) {
      if (scrollY >= productFilterOgTop) {
        PRODUCT_FILTER.setAttribute('data-fixed', '');
      } else {
        PRODUCT_FILTER?.removeAttribute('data-fixed');
      }
    }
  
    if (window.innerWidth >= BREAKPOINT) {
      handleFilter(BLOG_FILTER, blogFilterOgTop, desktopFilterHeight, scrollY);
    } else {
      handleFilter(BLOG_FILTER_MOBILE, mobileBlogFilterOgTop, mobileFilterHeight, scrollY);
    }
  };

  const handleModalButtons = () => {
    if ( !PRODUCT_FILTER ) return

    const OPEN_BUTTON = PRODUCT_FILTER.querySelector('[data-bs-toggle]')
    const CLOSE_BUTTON = PRODUCT_FILTER.querySelector('[data-bs-dismiss]')

    const buttons = [OPEN_BUTTON, CLOSE_BUTTON]

    if ( buttons.includes(null) ) return
    
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        const btn = e.currentTarget
        const btnDataset = btn.dataset

        if ( 'bsToggle' in btnDataset ) {
          document.body.setAttribute('data-filter-open', '')
        }

        if ( 'bsDismiss' in btnDataset ) {
          document.body.removeAttribute('data-filter-open')
        }
      })
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    setFilterLayouts();
    handleModalButtons();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateFilterLayouts);
  })
}

export default StickyFilters;